<script lang="tsx" setup>
import { ref } from "vue";
import {setWindowTitle} from "@zyzgroup/core-web"
import LayoutPage from "../layout/LayoutPage.vue";
import { useRoute } from "../../hooks";

// for merge ce shadow-root styles
defineOptions({
  inheritAttrs: true,
  customOptions: { LayoutPage }
});

const props = withDefaults(
  defineProps<{
    src?: string; // https://erichd2.oss-cn-shanghai.aliyuncs.com/0000/0002/2159
    title?: string;
  }>(),
  {
    src: "",
    title: ""
  }
);

const route = useRoute();
setWindowTitle(typeof route.params.title == "string" ? route.params.title : props.title);
const src = decodeURIComponent(typeof route.params.src == "string" ? route.params.src : props.src);

</script>

<template>
  <LayoutPage>
    <div class="view-document">
      <img
        class="img"
        :src="src"
      ></img>
    </div>
  </LayoutPage>
</template>

<style scoped>
.view-document {
  box-sizing: border-box;
  width: 100%;
  padding: 15px;
}
.img {
  width: 100%;
}
</style>
